/**
 * @copyright Copyright (c) Mathieu Vanbeselaëre
 */

// ** File summary ** //
// => ** Explain here what this code does in the project ** //
//

// ************** GSAP animation modules (Uncomment required gsap library!) ************** //
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger"; gsap.registerPlugin(ScrollTrigger);
// import ScrollSmoother from "gsap/ScrollSmoother"; gsap.registerPlugin(ScrollSmoother);
// import ScrollToPlugin from "gsap/ScrollToPlugin"; gsap.registerPlugin(ScrollToPlugin);
// import DrawSVGPlugin from "gsap/DrawSVGPlugin"; gsap.registerPlugin(DrawSVGPlugin);
// import MorphSVG from "gsap/MorphSVGPlugin"; gsap.registerPlugin(MorphSVG);
import SplitText from "gsap/SplitText"; gsap.registerPlugin(SplitText);
// *=====================================================================================* //

const FADE_FAST = 250;
const FADE_SLOW = 2000;
const ROTATION_INTERVAL = 200;

const waitTransition = (el) => new Promise((resolve) => {
    el.addEventListener('transitionend', resolve, { once: true });
});

const preloadImage = (url) => new Promise((resolve, reject) => {
    const loader = new Image();
    loader.onload = resolve;
    loader.onerror = reject;
    loader.src = url;
});

const setFadeDuration = (fade, ms) => {
    fade.style.setProperty('--inat-fade-duration', `${ms}ms`);
};

const fadeOverlay = async (fade, opacity, duration) => {
    setFadeDuration(fade, duration);
    fade.style.opacity = String(opacity);
    await waitTransition(fade);
};

const replaceImage = async (img, url, duration = FADE_FAST) => {
    const fade = img.parentElement?.querySelector('.inat_grid__fade');
    if (!fade) {
        img.src = url;
        return;
    }

    try {
        await preloadImage(url);
        await fadeOverlay(fade, 1, duration);
        img.src = url;
        await fadeOverlay(fade, 0, duration);
    } catch {
        // skip failed loads
    }
};

const pickRandom = (items) => items[Math.floor(Math.random() * items.length)];

const fetchInatUrls = (config) => {
    const formData = new FormData();
    formData.append(config.csrfTokenName, config.csrfTokenValue);

    return fetch(config.assetUrlsAction, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
    }).then((response) => {
        if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
        }
        return response.json();
    });
};

const initInatGrid = async () => {
    const config = window.inatConfig;
    const gridImages = [...document.querySelectorAll('.inat_grid img')];
    if (!config?.assetUrlsAction || !gridImages.length) {
        return;
    }

    try {
        const urls = await fetchInatUrls(config);
        if (!urls.length) {
            return;
        }

        await Promise.all(gridImages.map((img) => replaceImage(img, pickRandom(urls), FADE_FAST)));
        console.log('[inat] asset urls', urls);

        setInterval(() => {
            replaceImage(pickRandom(gridImages), pickRandom(urls), FADE_SLOW);
        }, ROTATION_INTERVAL);
    } catch (error) {
        console.error('[inat] failed to load asset urls', error);
    }
};

export const home = () => {
    const heroVideo = document.querySelector('.hero__video');
    if (heroVideo && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const revealVideo = () => {
            heroVideo.classList.add('is-ready');
            heroVideo.play().catch(() => {});
        };

        if (heroVideo.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA) {
            revealVideo();
        } else {
            heroVideo.addEventListener('canplay', revealVideo, { once: true });
        }
    }

    const heroTitleContainer = document.querySelector('.hero_title');
    const heroH1 = document.querySelector('.hero h1');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (heroH1 && heroTitleContainer && !prefersReducedMotion) {
        const heroTitle = SplitText.create(heroH1, {
            type: 'words',
            delimiter: '<br>'
        });

        gsap.set(heroH1, { visibility: 'visible' });
        gsap.from(heroTitle.words, {
            y: 50,
            autoAlpha: 0,
            duration: 2,
            delay: 1,
            ease: 'power1.out',
            stagger: 0.33
        });

        gsap.to(heroTitleContainer, {
            autoAlpha: 0,
            scrollTrigger: {
                trigger: ".project",
                start: "top bottom",
                end: "top top",
                scrub: true,
            },
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initInatGrid);
    } else {
        initInatGrid();
    }

    const inatWidget = document.querySelector('.inat_widget');
    if (inatWidget) {
        const inatValue = inatWidget.querySelector('.inat_widget__value');
        const targetProgress = parseFloat(inatWidget.dataset.progress);
        const progress = { value: 0 };

        if (inatValue && !Number.isNaN(targetProgress)) {
            const widgetScrollStart = window.matchMedia('(max-width: 768px)').matches
                ? 'top 75%'
                : 'top center';

            gsap.to(progress, {
                value: targetProgress,
                duration: 1.5,
                ease: 'power2.out',
                scrollTrigger: {
                    trigger: '.inat',
                    start: widgetScrollStart,
                    once: true,
                },
                onUpdate: () => {
                    inatWidget.style.setProperty('--progress', progress.value);
                    inatValue.textContent = `${progress.value.toFixed(1)}%`;
                },
            });
        }
    }

    return;
};
